
import DEFConfig from '@/config/defaults'
import AMSConfig from '@/config/amsterdam'
import PNCConfig from '@/config/park-n-charge'
import GORConfig from '@/config/go-ral'
import OPCConfig from '@/config/opcharge'
import RVBConfig from '@/config/rvb'
import VLAConfig from '@/config/vlaanderen'


/******************************************************************************
 * Select and export the Config of the active tenant
 */
const ConfigByTenant = {
  'amsterdam': AMSConfig,
  'opcharge': OPCConfig,
  'go-ral': GORConfig,
  'park-n-charge': PNCConfig,
  'rvb': RVBConfig,
  'vlaanderen': VLAConfig,
}

export const Config = Object.assign(DEFConfig, (ConfigByTenant[process.env.VUE_APP_TENANT] || {}))

/**
 * For development purposes, allow narrowing down to
 */
if (process.env.VUE_APP_MUNICODE) {
  const filterOnCodes = `${process.env.VUE_APP_MUNICODE}`.replace(/\s+/g, '').split(',')
  const filteredMunicipalityOptions = Config.municipalityOptions
    .filter(option => filterOnCodes.includes(option.value))
  if (filteredMunicipalityOptions.length) {
    Config.municipalityOptions = filteredMunicipalityOptions
  }
}

/******************************************************************************
 * Export config components
 */
export const tenantName = Config.tenantName
export const tenantAcronym = Config.tenantAcronym
export const tenantSlug = Config.tenantSlug
export const reasonOptions = Config.reasonOptions
/**
 * Status = "accepted" || "rejected" || etc.
 * Reason = "own-location" || "documents" || etc.
 */
export const reasonOptionsByStatusAndReason = Config.reasonOptions.reduce((acc, reason) => {
  acc[reason.status] = acc[reason.status] || {}
  acc[reason.status][reason.value] = reason
  return acc
}, {})

export const navigationConfig = Config.access
export const monitoringConfig = Config.monitoring
export const searchConfig = Config.search
export const onHoldReasons = Config.onHoldReasons
export const cancelReasons = Config.cancelReasons
export const ChargingStationVersion = Config.ChargingStationVersion
export const municipalityOptions = Config.municipalityOptions
export const chargePointOperatorField = Config.chargePointOperatorField
export const DateOfCommissioningFields = Config.DateOfCommissioningFields
export const steps = Config.steps
export const stepComponents = Config.stepComponents || {}
export const dataLayers = Config.dataLayers || {}
export const mapOptions = Config.mapOptions || ''
export const image = Config.image || {}
export const contractorsByMunicipalityCode = Config.contractorsByMunicipalityCode || {}
export const vkbStatuses = Config.vkbStatuses
export const visibleRequestsByRealisationStatuses = Config.visibleRequestsByRealisationStatuses
export const visibleRecordsByStatus = Config.visibleRecordsByStatus
export const tour = Config.tour
export const benchmarkMenu = Config.benchmarkMenu
export const gridConnectionValues = Config.gridConnectionValues
export const assetManagementFields = Config.assetManagementFields
export const operatorsByMunicipalityCode = Config.operatorsByMunicipalityCode
export const canResetDateValue = Config.canResetDateValue
export const requestMapShowActiveRedMarker = Config.requestMapShowActiveRedMarker
export const preparationDateFields = Config.preparationDateFields
export const usesPlannedRealisationFields = Config.usesPlannedRealisationFields
export const cpoList = []

// Genrally uses default menu
export const AdminMenu = Config.AdminMenu || []
export const ReportingMenu = Config.ReportingMenu || []
export const ManualsMenu = Config.ManualsMenu || []

export const LocationPickerDiameter = Config.LocationPickerDiameter || 200 // meters



/******************************************************************************
 * Helper methods
 */
export const roleToRoleLabel = (role) => {
  switch (role) {
    case 'cpo':
      return 'CPO'
    case 'municipality':
      return 'Gemeente'
    case 'admin':
      return 'Beheerder'
    case 'caseworker':
    case 'rvb':
      return 'Medewerker'
    case 'customer':
      return 'Klant'
    case 'guest':
    case 'caseviewer':
      return 'Gast'
  }
  return ''
}


export const stepNumbersByEditor = steps.reduce((result, step) => {
  step.access.edit.forEach(editor => {
    result[editor] = result[editor] || []
    result[editor].push(step.step || step.short)
  })

  return result
}, {})


export const stepsByUuid = steps.reduce((result, step) => {
  result[step.uuid] = step
  return result
}, {})

export const realisationProcessStatusTranslations = {
  completed: 'Afgerond',
  cancelled: 'Geannuleerd',
  onhold: 'On hold',
}

/******************************************************************************
 * RVB CONFIG
 */

export const customers = [
  'Belastingdienst',
  'Belastingdienst/EZ',
  'BZK',
  'BZK/FMH',
  'BZK/IKPD',
  'BZK/J&V',
  'CJIB min J&V',
  'CVTE',
  'Defensie',
  'DJI',
  'Europol',
  'EZK',
  'IND',
  'J&V/OCW',
  'KNMI',
  'MinFin',
  'NVWA',
  'OM',
  'Raad van State',
  'Rijkskantoor',
  'RvdK',
  'Rvdr',
  'RWS',
  'Staatsbosbeheer/Rijksdienst Cultureel Erfgoed',
]
export const AssetManagers = [
  'Abdelkarim el Massoudi',
  'Alle de Vries',
  'Annet Baar',
  'Arnoud Onderstal',
  'Carmen Haak',
  'Colette Bosveld',
  'Cristian Niţă',
  'Dennis Blom',
  // 'E.A. Brands',
  'Irma van Ruiten',
  'Jacco van Leeuwen',
  'Jan Otto Claus',
  'Jelle Reinalda',
  'Joop Hoppers',
  'Joris Spits',
  'Julia Becker',
  'Juliette Eldin',
  'Kim Bezem',
  'Lilian Rahimbaks-Mangroelal',
  'Linda Kneepkens',
  'Lisanne van Heeswijk',
  'Mark Verheijen',
  'Martijn de Haan',
  'Michael Russeler',
  'Mohamed Jabouri',
  'Monique Hielkema',
  'Niels Megens',
  'Norbert Izaks',
  'Peter Floor',
  'Peter van Dord',
  'Peter van Riet',
  'Peter van Zon',
  'Ramzy Feyzi',
  'René Buitenhek',
  'René Ligtvoet',
  'Rob Ammerlaan',
  'Sjoukje Bouma',
  'Twan Dijkhuizen',
  // 'V.A. van Beek',
  'Youri Zwanink',
]
export const  ObjectManagers = [
  'A.G.J. van den Berg',
  'Alexander Blaak',
  'André Stellingwerf',
  'Arnold Guijken',
  'Bart de Korte',
  'Bas Mulder',
  'Bert Vermeulen',
  'Bjorn Hendriks',
  'Carmen Storm',
  'Casper Brinkman',
  'Cindy Gulikers',
  'Claudine Calkoen',
  'Coen Wijen',
  'Coos Stoof',
  'Dirk Franken',
  'Edwin Hagedoorn',
  'Edwin Koree',
  'Ewout van Lente',
  'Frans van As',
  'Gerco van Alfen',
  'Guido Min',
  'Han Broens',
  'Hans van Boggelen',
  'Herman Meines',
  'Herman Wielaert',
  'Huub Bercx',
  'Jan Kersten',
  'Jennifer Daly',
  'Jeroen Dieben',
  'Jeroen Verheij',
  'Jo-Ann Hoekstra',
  'Jorrit Hoekstra',
  'Koen Fehrmann',
  'Linda van Kasteren',
  'Madelon van Leusden',
  'Marc Sambeek',
  'Marco Petri',
  'Nanja Vlasveld',
  'Nico Laumen',
  'Niek Zandee',
  'Paul Verkoelen',
  'Peter Darwinkel',
  'Pieter Olivier',
  'Quirine Cambier van Nooten',
  'Raoul Hupsel',
  'Raymon Meij',
  'Rene Langendoen',
  'Richard Bisscheroux',
  'Rintje Mulder',
  'Rob Gebuis',
  'Rob Montanus',
  'Rob Vlerken',
  'Roel Kuijer',
  'Ronald Bongers',
  'Ronald Bouman',
  'Ruud van Doorne',
  'Sebastiaan Verschoor',
  'Sven Rodenburg',
  'Tom van Moerkerk',
  'Vidjai Poeran',
  'Vincent Loeffen',
  'Walter Goessens',
  'Willemien Kimmel',
  'William Gesthuizen',
  'Wim Beije',
  'Wim Bovy',
]
export const ObjectVisions = [
  'Afstoot verwacht',
  'Afstoot zeker',
  'Flexibel - kort',
  'Flexibel - lang',
  'Niet strategisch',
  'Strategisch',
]
export const ObjectTypes = [
  'Rijkskantoor',
  'Bijzondere specialty',
  'Specialty',
  'Defensie',
]
export const PropertyRights = [
  'Kantoren - Eigendom',
  'Kantoren - Huur',
  'Defensie (geen eigendom)',
]
export const Provinces = [
  'Drenthe',
  'Flevoland',
  'Friesland',
  'Gelderland',
  'Groningen',
  'Limburg',
  'Noord-Brabant',
  'Noord-Holland',
  'Overijssel',
  'Utrecht',
  'Zeeland',
  'Zuid-Holland',
]

export const Regions = [
  'Noord',
  'Noord-West',
  'Oost',
  'Zuid',
  'Zuid-West',
]

export const RPL = [
  { name: 'Aldert Klugkist', id: 'auth0|60112d465238fb006960d979' },
  { name: 'Annemarie Eriks', id: 'auth0|62bea828c1f5b79cdb36897c' },
  { name: 'Claire Hoffman', id: 'auth0|602e24e2a38832007006f30a' },
  { name: 'Esther Beijlsmit', id: 'auth0|602e076ed20a6f006ffd531f' },
  { name: 'Esther Rinsampessij', id: 'auth0|602e074be199770069d2819c' },
  { name: 'Koen Fehrmann', id: 'auth0|60b5ceccea19400033f5098a' },
  { name: 'Mark Sodaar', id: 'auth0|62f617c14e9a75601b24ec74' },
  { name: 'Martijn Kuijs', id: 'auth0|602e0717d20a6f006ffd5191' },
  { name: 'Simon Datema', id: 'auth0|602e06ff19a8a10071819e1d' },
  { name: 'Stefan Lathouwers', id: 'auth0|602e07341819a10070dca6d6' },
  // { name: 'Test account Jochem', id: 'auth0|602d900217ccd80068614194' },
  { name: 'Walter Bruisten', id: 'auth0|602e069281ae2c006ae28695' },
]


